import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
 MdNotifications,
 MdSettings,
 MdLogout,
 MdUploadFile,
} from "react-icons/md";
import { logout } from "../../../store/Login/actions";
import { useDispatch } from "react-redux";
import { Nav } from "react-bootstrap";
const AnalysisHeader = () => {
 const dispatch = useDispatch();
 const handleLogout = () => {
  logout()(dispatch);
  // navigate("/")
 };
 return (
  <>
   {/* <input type='search' className='custom-search-input' placeholder='Search...' /> */}
   <Nav className="ms-auto">
    <Nav.Link as={NavLink} to="/upload_sheet">
     <MdUploadFile /> Upload LCC Sheet
    </Nav.Link>
    <Nav.Link className="header-nav-items" onClick={handleLogout}>
     <MdLogout /> Logout
    </Nav.Link>
   </Nav>
  </>
 );
};

export default AnalysisHeader;
